import LogoSBM from '../vectors/logo-sbm';
import LogoGranicus from '../vectors/logo-granicus';
import LogoTithely from '../vectors/logo-tithely';
import LogoOneFMA from '../vectors/logo-onefma';
import LogoDW from '../vectors/logo-dw';

type LogoProps = {
  logoName: string | null,
  width?: string,
}

const DisplayLogo = ({ logoName, width }: LogoProps) => {
  switch(logoName) {
    case "Granicus":
      return <LogoGranicus size="210" />
    case "Tithely":
      return <LogoTithely size="200" />
    case "SBM":
      return <LogoSBM size="200" />
    case "DW":
      return <LogoDW size="64" />
    case "OneFMA":
      return <LogoOneFMA size="200" primary="#000" />
    case "mSpot":
      return <img src="\img\mspot\mSpot-logo.png" width="75" height="75" alt="mSpot logo" />
    default:
      return null;
  };
};

export default DisplayLogo;
